<template>
  <v-bottom-navigation grow fixed dark class="bottom-nav-bar primary lighten-1">
    <!-- home -->
    <v-btn :to="{ name: 'Home' }">
      <span>{{ $t("bottom.home") }}</span>
      <v-icon>$home</v-icon>
    </v-btn>
    <v-btn @click="handleLogin('/profile/')">
      <span>{{ $t("bottom.account") }}</span>
      <v-icon>$profile</v-icon>
    </v-btn>
    <!-- ordini -->
    <v-btn @click="handleLogin('/profile/orders')">
      <span>{{ $t("bottom.orders") }}</span>
      <v-icon>$orders</v-icon>
    </v-btn>
    <!-- prodotti -->
    <v-btn @click.prevent.stop="drawerLeft = !drawerLeft">
      <span>{{ $t("bottom.products") }}</span>
      <v-icon>$menu</v-icon>
    </v-btn>
    <!-- carrello -->
    <v-btn
      @click="!isAuthenticated ? handleLogin() : (drawerRight = !drawerRight)"
    >
      <v-badge
        :content="totalItems"
        :value="totalItems > 0"
        :key="totalItems"
        transition="bounce"
        color="secondary darken-1 default--text font-weight-bold"
        overlap
        offset-x="20"
        class="d-flex flex-column"
      >
        <v-icon>$cart</v-icon>
        <span>{{ $t("bottom.cart") }}</span>
      </v-badge>
    </v-btn>
  </v-bottom-navigation>
</template>

<script>
import login from "~/mixins/login";
import { forEachCartItem } from "~/service/ebsn";
import { mapActions, mapGetters, mapState } from "vuex";
export default {
  mixins: [login],
  data() {
    return {};
  },
  methods: {
    ...mapActions({
      updatedDrawerLeft: "app/updatedDrawerLeft",
      updatedDrawerRight: "app/updatedDrawerRight",
      updatedDrawerLinks: "app/updatedDrawerLinks"
    }),
    async handleLogin(path) {
      if (this.isAuthenticated) {
        this.$router.push(path);
      } else {
        let isLoggedIn = await this.doLogin();
        if (isLoggedIn) {
          this.$router.push(path);
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    }),
    ...mapState({
      storeDrawerLeft: state => state.app.drawerLeft,
      storeDrawerRight: state => state.app.storeDrawerRight,
      storeDrawerLinks: state => state.app.drawerLinks,
      cart: ({ cart }) => cart.cart
    }),
    totalItems() {
      let total = 0;
      forEachCartItem(this.cart, function(item) {
        total += item.quantity > 0 ? item.quantity : 1;
      });
      return total;
    },
    drawerLeft: {
      get() {
        return this.storeDrawerLeft;
      },
      set(value) {
        this.updatedDrawerLeft(value);
      }
    },
    drawerRight: {
      get() {
        return this.storeDrawerRight;
      },
      set(value) {
        this.updatedDrawerRight(value);
      }
    },
    drawerLinks: {
      get() {
        return this.storeDrawerLinks;
      },
      set(value) {
        this.updatedDrawerLinks(value);
      }
    }
  }
};
</script>
<style lang="scss">
// ==========================================
// 1. STILI GENERICI (Web / Fallback base)
// ==========================================
.v-main {
  padding-bottom: calc(
    #{$bottom-navigation-bar-height} + env(safe-area-inset-bottom) * 4
  ) !important;
}
.keyboard-open {
  .v-main {
    padding-bottom: calc(80px + env(safe-area-inset-top) * 4) !important;
  }
}
.platform-ios {
  .v-main {
    padding-bottom: calc(210px + env(safe-area-inset-top)) !important;
  }
}
.platform-ios.keyboard-open {
  .v-main {
    padding-bottom: calc(110px + env(safe-area-inset-top)) !important;
  }
}
</style>
<style scoped lang="scss">
.bottom-nav-bar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}
.platform-ios {
  .bottom-nav-bar {
    //height: $bottom-navigation-bar-height-ios !important;
    position: fixed;
    bottom: 0;
    padding-top: constant(safe-area-inset-top);
    padding-left: constant(safe-area-inset-left);
    padding-right: constant(safe-area-inset-right);
    max-height: calc(
      #{$bottom-navigation-bar-height-ios} + env(safe-area-inset-top) + 20px
    ) !important;
    height: calc(
      #{$bottom-navigation-bar-height} + env(safe-area-inset-top) + 20px
    ) !important;
    padding-top: calc(env(safe-area-inset-top));
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
    padding-bottom: calc(110px + env(safe-area-inset-bottom));
    .v-icon {
      font-size: 32px !important;
    }
  }
}
.v-bottom-navigation .v-btn {
  min-width: auto !important;
  padding: 0 5px;
  font-size: 0.9rem !important;
  .v-btn__content {
    color: $white !important;
    .v-icon {
      font-size: 28px;
    }
  }
}

// Quando la tastiera è aperta (generico) nascondi la barra
.keyboard-open {
  .bottom-nav-bar {
    display: none !important;
  }
  .v-main {
    padding-bottom: 20px !important; // Ripristina lo spazio utile per scorrere i campi di testo
  }
}

// ==========================================
// 2. PIATTAFORMA ANDROID (Edge-to-Edge reale)
// ==========================================
body.android {
  // 1. ELIMINA LO SPAZIO BIANCO IN ALTO
  // Rimuove i margini che spingono l'intera app verso il basso
  .v-application,
  &.v-application--wrap,
  #app {
    padding-top: 0px !important;
    margin-top: 0px !important;
  }

  // Estende la navbar superiore fin sotto la barra delle notifiche (Status Bar)
  // Nota: ho incluso i selettori standard di Vuetify, aggiungi la tua classe se diversa
  .v-app-bar,
  .v-toolbar,
  .top-nav-bar {
    top: 0 !important;
    // padding-top: env(safe-area-inset-top, 0px) !important;
    // Calcola l'altezza totale includendo la safe area top per non tagliare il contenuto interno
    // height: calc(56px + env(safe-area-inset-top, 0px)) !important;
    height: #{$statusbarheight} !important;
  }

  // 2. OTTIMIZZAZIONE BOTTOM NAV BAR (Icone centrate e spazio ridotto)
  .bottom-nav-bar {
    // Altezza fissa standard Android (56px) + lo spazio delle gesture sul fondo
    height: calc(
      #{$bottom-navigation-bar-height} + env(safe-area-inset-bottom, 0px)
    ) !important;

    // padding-top: 0 !important;
    // padding-bottom: env(safe-area-inset-bottom, 0px) !important;
    padding-left: env(safe-area-inset-left, 0px);
    padding-right: env(safe-area-inset-right, 0px);

    // Centra perfettamente le icone ed evita che galleggino nel vuoto
    display: flex !important;
    align-items: center !important;
    justify-content: space-around !important;
  }

  // 3. GESTIONE CONTENUTO PRINCIPALE (Scorrimento perfetto)
  .v-main {
    // Il contenuto si ferma esattamente dove inizia la barra icone reale
    padding-bottom: calc(
      (#{$bottom-navigation-bar-height} * 2) + env(safe-area-inset-bottom, 0px) +
        10px
    ) !important;
  }

  // Forza Vuetify a non ereditare min-height strane che creano scroll vuoti
  .v-application--wrap {
    min-height: 100vh !important;
  }

  // 4. FIX BOTTONE "TORNA ALL'INIZIO"
  // Spinge il pulsante arancione sopra la bottom bar senza coprirlo
  // (Adatta il selettore .scroll-top se usi una classe specifica nel tuo codice)
  .v-btn[class*="scroll"],
  .v-btn[class*="top"],
  .scroll-to-top {
    bottom: calc(
      #{$bottom-navigation-bar-height} + env(safe-area-inset-bottom, 0px) + 16px
    ) !important;
  }

  // 5. GESTIONE TASTIERA APERTA
  &.keyboard-open {
    .bottom-nav-bar {
      display: none !important; // Nasconde la barra sotto i tasti
    }
    .v-main {
      padding-bottom: 0px !important; // Sfrutta tutto lo schermo per scrivere
    }
  }
}
</style>
